export default "__VITE_ASSET__Glah5Kbj__"